import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onPersonSourcesInternal = action("onPersonSourcesInternal", event => ({
    event,
    owaType: "personSourcesInternal",
})) as OwaNovaActionUnion<"personSourcesInternal">;
